import { Stepper } from "@JohnLewisPartnership/jl-design-system/dist/components/stepper/Stepper";
import { CardComponentProps } from "@~/types/types";
import { useProductCardEvent } from "@~/contexts/ProductCardEventContext/ProductCardEventContext.tsx";
import { productCardEvents } from "@~/contexts/ProductCardEventContext/productCardEvents";
import { isRetiredProduct } from "@~/utils/product.ts";

export function QuantityWanted({
  product,
}: Pick<CardComponentProps, "product">) {
  const dispatchEvent = useProductCardEvent();

  if (product.wanted === undefined) {
    return null;
  }
  const isRetired = isRetiredProduct(product);
  return (
    <div data-component="QuantityWanted">
      <Stepper
        id="stepper"
        labelText="Quantity wanted"
        max={10}
        min={0}
        name="quantity"
        onChange={(quantity) => {
          dispatchEvent(productCardEvents.quantityWantedUpdate, {
            quantityWanted: quantity,
          });
        }}
        value={product.wanted}
        disabled={isRetired}
      />
    </div>
  );
}
